import { grey } from "./colors/index.js";
const border = (mode)=>'light' === mode ? {
        prominent: grey["300"],
        subtle: grey["150"]
    } : {
        prominent: grey["600"],
        subtle: grey["850"]
    };
export { border };

//# sourceMappingURL=border.js.map